"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Group;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _helpers2 = require("../../helpers");

var _Overlay = _interopRequireDefault(require("../Overlay"));

var sc = _interopRequireWildcard(require("./Group.styles"));

var _useOffsetScroll = _interopRequireDefault(require("../../hooks/useOffsetScroll"));

var propTypes = {
  children: _propTypes["default"].node.isRequired,
  offsetY: _propTypes["default"].number,
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  offsetY: 0,
  zIndex: (0, _helpers.zValue)(6)
};

function Group(props) {
  var children = props.children,
      offsetY = props.offsetY,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "offsetY"]);

  var _extractChildren = (0, _helpers2.extractChildren)(children, ["Panel", "Panel.Overlay"]),
      sidePanels = _extractChildren.Panel,
      OverlayExtracted = _extractChildren["Panel.Overlay"];

  if (!(0, _isArray["default"])(sidePanels)) {
    throw new Error("<Panel.Group /> is intented to be use with two or more Panels");
  }

  var offsetScroll = (0, _useOffsetScroll["default"])(offsetY);

  if (sidePanels.filter(function (sidePanel) {
    return !sidePanel.props.isOpen;
  }).length === sidePanels.length) {
    return null;
  }

  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, OverlayExtracted, /*#__PURE__*/_react["default"].createElement(sc.Group, (0, _extends2["default"])({}, moreProps, {
    offsetY: offsetScroll,
    "data-pka-anchor": "panel.group"
  }), sidePanels.map(function (sidePanel) {
    return /*#__PURE__*/_react["default"].cloneElement(sidePanel, {
      isInline: true,
      groupOffsetY: offsetY
    });
  }))), document.body);
}

Group.propTypes = propTypes;
Group.defaultProps = defaultProps;
Group.Overlay = _Overlay["default"];
//# sourceMappingURL=Group.js.map